import { ChevronDown, ChevronFirst, ChevronLast, ChevronUp } from 'lucide-react'
import { FormReorderType } from './type'

import { FormFieldProps } from './type'
import { useFormContext } from 'react-hook-form'
import { useContext, useMemo } from 'react'
import { DetailManyToOneContext } from '../DetailManyToOneProvider'

export const FormReorderField = ({
  data,
  field,
}: FormFieldProps<FormReorderType>) => {
  const context = useFormContext()

  const { array } = useContext(DetailManyToOneContext)

  const index = useMemo(() => {
    if (typeof field.name === 'string') {
      const [parent] = field.name.split('.')

      const match = parent.match(/\[(\d+)\]$/)
      if (match) {
        return Number(match[1])
      }
    }

    return 0
  }, [field.name])

  const onClickMove = (count: number) => {
    let nextValue = index + count

    if (nextValue < 0) {
      nextValue = 0
    }

    if (nextValue > array.fields.length - 1) {
      nextValue = array.fields.length - 1
    }

    array.update(index, {
      ...array.fields[index],
      order: nextValue + 1,
    })
    array.update(nextValue, {
      ...array.fields[nextValue],
      order: index + 1,
    })
    array.swap(index, nextValue)
  }

  return (
    <div className="inline-flex items-center gap-2">
      <div className="inline-flex flex-col items-center gap-2">
        <div className="flex items-center gap-2">
          <ChevronFirst
            size={20}
            onClick={() => onClickMove(-Infinity)}
            className="rotate-90 cursor-pointer rounded hover:bg-muted-foreground/20"
          />
          <ChevronUp
            size={20}
            onClick={() => onClickMove(-1)}
            className="cursor-pointer rounded hover:bg-muted-foreground/20"
          />
        </div>
        <div className="flex items-center gap-2">
          <ChevronLast
            size={20}
            onClick={() => onClickMove(+Infinity)}
            className="rotate-90 cursor-pointer rounded hover:bg-muted-foreground/20"
          />
          <ChevronDown
            size={20}
            onClick={() => onClickMove(1)}
            className="cursor-pointer rounded hover:bg-muted-foreground/20"
          />
        </div>
      </div>
      <div className="text-sm text-muted-foreground">{field.value}</div>
    </div>
  )
}
